// ** React Imports
import { Link, useLocation } from 'react-router-dom'
import React from 'react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
// ** Icons Imports
import { ChevronLeft } from 'react-feather'
import { Controller, useForm } from 'react-hook-form'
// ** Custom Components
import InputPassword from '@components/input-password-toggle'
import useJwt from '@src/auth/jwt/useJwt'
// ** Reactstrap Imports
import { Card, CardBody, CardTitle, CardText, Form, Button, FormGroup, FormFeedback } from 'reactstrap'
import { resetUserPassword } from './Components/Datatable/store/action'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// ** Styles
import { useState } from 'react'
import '@styles/react/pages/page-authentication.scss'
import { Spinner } from 'reactstrap'
import toast from "react-hot-toast";
const ResetPassword = () => {

    const defaultValues = {
        password: '',
        confirmPassword: ''
    }

    const SignupSchema = yup.object().shape({
        password: yup.string().min(8).required(),
        confirmPassword: yup
            .string()
            .min(8)
            .oneOf([yup.ref('password'), null], 'Passwords must match')
    })

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({ defaultValues, resolver: yupResolver(SignupSchema) })

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const onSubmit = (inputs, e) => {
        setLoading(true)
        e.preventDefault()
        const { password, confirmPassword } = inputs
        useJwt.setHeader(token)
        dispatch(resetUserPassword({ password, confirmPassword }))
            .then(({ data }) => {
                setLoading(false)
                if (data.status) {
                    toast.success("Password updated Successfully")
                    navigate('/login')
                } else {
                    toast.error("Invalid")
                }
            }).catch(function ({ response }) {
                setLoading(false)
                let errors = response?.data?.message
                toast.error(errors)
            })
    }

    return (
        <div className='auth-wrapper auth-basic px-2'>
            <div className='auth-inner my-2'>
                <Card className='mb-0'>
                    <CardBody>
                        {/* <Link className='brand-logo' to='/' onClick={e => e.preventDefault()}>
                            <svg viewBox='0 0 139 95' version='1.1' height='28'>
                                <defs>
                                    <linearGradient x1='100%' y1='10.5120544%' x2='50%' y2='89.4879456%' id='linearGradient-1'>
                                        <stop stopColor='#000000' offset='0%'></stop>
                                        <stop stopColor='#FFFFFF' offset='100%'></stop>
                                    </linearGradient>
                                    <linearGradient x1='64.0437835%' y1='46.3276743%' x2='37.373316%' y2='100%' id='linearGradient-2'>
                                        <stop stopColor='#EEEEEE' stopOpacity='0' offset='0%'></stop>
                                        <stop stopColor='#FFFFFF' offset='100%'></stop>
                                    </linearGradient>
                                </defs>
                                <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                                    <g id='Artboard' transform='translate(-400.000000, -178.000000)'>
                                        <g id='Group' transform='translate(400.000000, 178.000000)'>
                                            <path
                                                d='M-5.68434189e-14,2.84217094e-14 L39.1816085,2.84217094e-14 L69.3453773,32.2519224 L101.428699,2.84217094e-14 L138.784583,2.84217094e-14 L138.784199,29.8015838 C137.958931,37.3510206 135.784352,42.5567762 132.260463,45.4188507 C128.736573,48.2809251 112.33867,64.5239941 83.0667527,94.1480575 L56.2750821,94.1480575 L6.71554594,44.4188507 C2.46876683,39.9813776 0.345377275,35.1089553 0.345377275,29.8015838 C0.345377275,24.4942122 0.230251516,14.560351 -5.68434189e-14,2.84217094e-14 Z'
                                                id='Path'
                                                className='text-primary'
                                                style={{ fill: 'currentColor' }}
                                            ></path>
                                            <path
                                                d='M69.3453773,32.2519224 L101.428699,1.42108547e-14 L138.784583,1.42108547e-14 L138.784199,29.8015838 C137.958931,37.3510206 135.784352,42.5567762 132.260463,45.4188507 C128.736573,48.2809251 112.33867,64.5239941 83.0667527,94.1480575 L56.2750821,94.1480575 L32.8435758,70.5039241 L69.3453773,32.2519224 Z'
                                                id='Path'
                                                fill='url(#linearGradient-1)'
                                                opacity='0.2'
                                            ></path>
                                            <polygon
                                                id='Path-2'
                                                fill='#000000'
                                                opacity='0.049999997'
                                                points='69.3922914 32.4202615 32.8435758 70.5039241 54.0490008 16.1851325'
                                            ></polygon>
                                            <polygon
                                                id='Path-2'
                                                fill='#000000'
                                                opacity='0.099999994'
                                                points='69.3922914 32.4202615 32.8435758 70.5039241 58.3683556 20.7402338'
                                            ></polygon>
                                            <polygon
                                                id='Path-3'
                                                fill='url(#linearGradient-2)'
                                                opacity='0.099999994'
                                                points='101.428699 0 83.0667527 94.1480575 130.378721 47.0740288'
                                            ></polygon>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </Link> */}
                        <CardTitle tag='h4' className='mb-0'>
                            <h2 className='brand-text text-primary text-center mt-2'>Reset Password</h2>
                        </CardTitle>
                        <CardText className='text-center'>Enter your new password.</CardText>
                        <Form className='auth-reset-password-form' onSubmit={handleSubmit(onSubmit)}>
                                <div className='mb-1'>
                                    <Controller
                                        id='password'
                                        name='password'
                                        control={control}
                                        render={({ field }) => (
                                            <InputPassword
                                                label='New Password'
                                                htmlFor='password'
                                                className='input-group-merge'
                                                invalid={errors.password && true}
                                                {...field}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                                                    field.onChange(value); // Set the value
                                                }}
                                                onKeyPress={(e) => {
                                                    // Prevent typing 'e', '+', '-', or any non-numeric character
                                                    if (/[^0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.password && <FormFeedback className='d-block'>{errors.password.message.replace('password', 'Password')}</FormFeedback>}
                                </div>
                                <div className='mb-1'>
                                    <Controller
                                        control={control}
                                        id='confirmPassword'
                                        name='confirmPassword'
                                        render={({ field }) => (
                                            <InputPassword
                                                label='Confirm New Password'
                                                htmlFor='confirmPassword'
                                                className='input-group-merge'
                                                invalid={errors.confirmPassword && true}
                                                {...field}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                                                    field.onChange(value); // Set the value
                                                }}
                                                onKeyPress={(e) => {
                                                    if (/[^0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.confirmPassword && (
                                        <FormFeedback className='d-block'>{ errors.confirmPassword.message.replace('confirmPassword', 'Confirm password')}</FormFeedback>
                                    )}
                                </div>
                                    
                            <Button.Ripple color='primary' type='submit' block>
                                {loading ? <Spinner color='white' size='sm' /> : ''}
                                <span className='ml-50'>Set New Password</span>
                            </Button.Ripple>
                        </Form>
                        <p className='text-center mt-2'>
                            <Link to='/login'>
                                <ChevronLeft className='rotate-rtl me-25' size={14} />
                                <span className='align-middle'>Back to login</span>
                            </Link>
                        </p>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default ResetPassword
